import { Button, Box, useTheme } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { tokens } from "../../../theme";
import React, { useEffect, useState } from "react";
import axios from "axios";
import Header from "../../Dashboard/Header";

import { useNavigate } from "react-router-dom";

const PREFERENCE_KEY = "infiniteAppUserPreferences";

//Local Variables
const BankUnRecoTrans = () => {
  const token = localStorage.getItem("token");
  const cmpid = localStorage.getItem("cmpid");
  const [pageSize, setPageSize] = useState(20);
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const navigate = useNavigate();
  const [BankRecData, SetBankRecData] = useState([]);
  const [selectedIds, setSelectedIds] = useState([]);

  // Load saved user preferences from localStorage
  const saved = localStorage.getItem(PREFERENCE_KEY);
  const preferences = saved
    ? JSON.parse(saved)
    : {
        rowHeight: 40,
        fontFamily: "Source Sans Pro",
        fontSize: 16,
        tableAlign: "center",
      };

  //call after Component load
  useEffect(() => {
    fetchData();
  }, [token, cmpid]);

  const fetchData = async () => {
    try {
      const response = await axios.post(
        process.env.REACT_APP_API_URL +
          "/bankreconciliation/witoutBankersDateVch",
        { cmpid: cmpid },
        {
          headers: { Authorization: token },
        }
      );
      const arrayData = response.data.rows;
      console.log("data", arrayData);
      SetBankRecData(arrayData);
    } catch (error) {
      console.log(error);
    }
  };

  // =================================================

  //rows for vouchers table
  const rows = Array.isArray(BankRecData)
    ? BankRecData.map((BnkData) => ({
        id: BnkData.vch_id,
        Date: BnkData.vch_date,
        partyName: BnkData.PartyName,
        BankDate: BnkData.vchB_bankersdate,
        BnkVchAmt: BnkData.vch_Amount,
      }))
    : [];

  //colums for vouchers table
  const columns = [
    {
      field: "Date",
      headerName: "Date",
      headerAlign: preferences.tableAlign,
      align: preferences.tableAlign,
      flex: 1,
    },

    {
      field: "partyName",
      headerName: "Party Ledger Name",
      headerAlign: preferences.tableAlign,
      align: preferences.tableAlign,
      flex: 1,
    },
    {
      field: "BankDate",
      headerName: "Bank Date",
      headerAlign: preferences.tableAlign,
      align: preferences.tableAlign,
      flex: 1,
    },
    {
      field: "BnkVchAmt",
      headerName: "Amount",
      headerAlign: preferences.tableAlign,
      align: preferences.tableAlign,
      flex: 1,
    },
  ];


  return (
    <>
      {/* show all voucher entry */}
      <Box mt="80px" ml="20px" mr="20px">
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Header
            title="Bank Reconcilation"
            subtitle="Bank Reconcilation List"
          />

          <Box display="flex" gap={2}>
            <Button
              variant="contained"
              size="small"
              sx={{
                backgroundColor: colors.blueAccent[700], // Custom background color
                color: colors.primary[150], // Custom text color
                "&:hover": {
                  backgroundColor: colors.blueAccent[700], // Maintain the same background on hover
                  color: colors.primary[150], // Maintain the same text color on hover
                },
              }}
              type="button"
              onClick={() => navigate("/Infinite/AutoBankReconcile")}
            >
              Auto Reconcile
            </Button>
            <Button
              variant="contained"
              size="small"
              sx={{
                backgroundColor: colors.blueAccent[700], // Custom background color
                color: colors.primary[150], // Custom text color
                "&:hover": {
                  backgroundColor: colors.blueAccent[700], // Maintain the same background on hover
                  color: colors.primary[150], // Maintain the same text color on hover
                },
              }}
              type="button"
              onClick={() => navigate("/Infinite/ManualReconcile")}
            >
              Manual Reconcile
            </Button>
          </Box>
        </Box>

        {/* Bank Statement entry Table  */}
        <Box
          height="74vh"
          sx={{
            "& .MuiDataGrid-root": { border: "none" },
            "& .MuiDataGrid-cell": { border: "none", cursor: "pointer" },
            "& .MuiDataGrid-columnHeaders": {
              backgroundColor: colors.blueAccent[700],
              borderBottom: "none",
            },
            "& .MuiDataGrid-virtualScroller": {
              backgroundColor: colors.primary[400],
            },
            "& .MuiDataGrid-footerContainer": {
              borderTop: "none",
              backgroundColor: colors.blueAccent[700],
            },
            "& .MuiDataGrid-cell:focus": { outline: "none" },
            "& .BReczoom-row:hover": {
              transform: "scale(1.01)",
              transition: "transform 0.2s ease-in-out",
              zIndex: 1,
              backgroundColor: colors.blueAccent[900],
            },
          }}
        >
          <DataGrid
            rows={rows}
            columns={columns}
            pageSize={pageSize}
            rowHeight={parseInt(preferences.rowHeight)}
            onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
            rowsPerPageOptions={[20, 50, 100]}
            getRowClassName={() => "BReczoom-row"}
            pagination
            checkboxSelection
            onSelectionModelChange={(newSelection) =>
              setSelectedIds(newSelection)
            }
          />
        </Box>
      </Box>
    </>
  );
};

export default BankUnRecoTrans;
